import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ClientDDL, ClientInfo } from "@/views/base/base.types";
import { SurveyResult, AlertZone } from "@/views/sidebar/survey/survey.types";
import { PatientSummary } from "@/views/summary/summary.types";
import tinycolor from "tinycolor2";

@Component({
  computed: {
    ...mapState("Survey", [
      "surveyAnswers",
      "phq9AlertZones",
      "gad7AlertZones",
      "sowsAlertZones",
      "bamAlertZones"
    ]),
    ...mapState("Summary", [
      "selectedPatientSummary"
    ]),
    ...mapState("Base", [
      "selectedClientDDL",
      "clientInfo"
    ])
  }
})
export default class ServiceMixin extends Vue {
  clientInfo!: ClientInfo[];
  selectedClientDDL!: ClientDDL;
  surveyAnswers!: SurveyResult[];
  phq9AlertZones!: AlertZone[];
  gad7AlertZones!: AlertZone[];
  sowsAlertZones!: AlertZone[];
  bamAlertZones!: AlertZone[];
  selectedPatientSummary!: PatientSummary;

  get selectedClient() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    ) ?? new ClientInfo;
  }

  getColor(index: number, type: string, background: boolean): string {
    const zoneMap: Record<string, AlertZone[]> = {
      "PHQ-9": this.phq9AlertZones,
      "GAD-7": this.gad7AlertZones,
      "SOWS": this.sowsAlertZones,
      "BAM": this.bamAlertZones,
    };

    const key = Object.keys(zoneMap).find(prefix => type.startsWith(prefix));
    const zones = key ? zoneMap[key] : [];
    const alertZone = zones.find(
      e => e.startZone <= index && e.endZone >= index
    );

    if (alertZone) {
      return background ? tinycolor(alertZone.color).brighten(5).toHexString() : 
        tinycolor(alertZone.color).darken(25).toHexString();
    }
    return "#FFFFFF";
  }

  getSupersetClass(valueChange: number) {
    return valueChange > 0 ? 'positive' : 'negative';
  }

  formatSuperset(valueChange: number) {
    if (valueChange === 0) return '';
    return valueChange > 0 ? `+${valueChange}` : `${valueChange}`;
  }
}